export const SEARCH_BUTTON_TEXT = `להצגת הנתונים`;

export const CITY_AUTOCOMPLETE_PLACEHOLDER = `בחרו עיר להצגת הנתונים`;
export const AREA_AUTOCOMPLETE_PLACEHOLDER = `בחרו שכונה להצגת נתוני השכונה`;

export const ROOM_SELECT_TITLE = `בחרו מספר חדרים:`;

export const TITLE = "נתונים לפי אזור";
